export const chipToggleDisabledStyle = theme => ({
  '&.Mui-disabled': {
    cursor: theme.tokens.ComponentChipDisabledCursor,
    backgroundColor: theme.tokens.ComponentChipDisabledBg,
    borderColor: theme.tokens.ComponentChipDisabledBorder,
    borderWidth: '1px',
    borderStyle: 'solid',
    opacity: 'unset',
    color: theme.tokens.ComponentChipDisabledColor,
    '&:hover': {
      backgroundColor: theme.tokens.ComponentChipDisabledBg,
      borderColor: theme.tokens.ComponentChipDisabledBorder,
      borderWidth: '1px',
      borderStyle: 'solid',
      color: theme.tokens.ComponentChipDisabledColor,
      cursor: theme.tokens.ComponentChipDisabledCursor
    }
  }
});
export const chipLinkDisabledStyle = theme => ({
  '&.Mui-disabled': {
    cursor: theme.tokens.ComponentChipDisabledCursor,
    backgroundColor: theme.tokens.ComponentChipDisabledBg,
    borderColor: theme.tokens.ComponentChipDisabledBorder,
    borderWidth: '1px',
    borderStyle: 'solid',
    color: theme.tokens.ComponentChipDisabledColor,
    opacity: 'unset',
    '.MuiChip-icon': {
      cursor: theme.tokens.ComponentChipDisabledCursor,
      backgroundColor: theme.tokens.ComponentChipDisabledBg,
      color: theme.tokens.ComponentChipDisabledColor
    },
    '& .MuiChip-deleteIcon': {
      cursor: theme.tokens.ComponentChipDisabledCursor,
      backgroundColor: theme.tokens.ComponentChipDisabledBg,
      color: theme.tokens.ComponentChipDisabledColor
    },
    '&:hover': {
      backgroundColor: theme.tokens.ComponentChipDisabledBg,
      borderColor: theme.tokens.ComponentChipDisabledBorder,
      borderWidth: '1px',
      borderStyle: 'solid',
      color: theme.tokens.ComponentChipDisabledColor,
      cursor: theme.tokens.ComponentChipDisabledCursor
    }
  }
});
export const chipFilterDisabledStyle = theme => ({
  '&.Mui-disabled': {
    cursor: theme.tokens.ComponentChipDisabledCursor,
    backgroundColor: theme.tokens.ComponentChipDisabledBg,
    borderColor: theme.tokens.ComponentChipDisabledBorder,
    borderWidth: '1px',
    borderStyle: 'solid',
    opacity: 'unset',
    color: theme.tokens.ComponentChipDisabledColor,
    '.MuiChip-icon': {
      cursor: theme.tokens.ComponentChipDisabledCursor,
      backgroundColor: theme.tokens.ComponentChipDisabledBg,
      color: theme.tokens.ComponentChipDisabledColor
    },
    '& .MuiChip-deleteIcon': {
      cursor: theme.tokens.ComponentChipDisabledCursor,
      backgroundColor: theme.tokens.ComponentChipDisabledBg,
      color: theme.tokens.ComponentChipDisabledColor
    },
    '&:hover': {
      backgroundColor: theme.tokens.ComponentChipDisabledBg,
      borderColor: theme.tokens.ComponentChipDisabledBorder,
      borderWidth: '1px',
      borderStyle: 'solid',
      color: theme.tokens.ComponentChipDisabledColor,
      cursor: theme.tokens.ComponentChipDisabledCursor
    }
  }
});